
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { VesselViewComponent } from './vessel-view/vessel-view.component';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Vessel',
          },
        component: VesselViewComponent,
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class VesselRoutingModule { }